import React, { useContext, useEffect, useMemo, useState } from "react";
import { Box, FormLabel, Grid, IconButton } from "@mui/material";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DataTable from "../../components/common/DataTable";
import { CREATE_TERM_CONDITIONS, DELETE_TERM_CONDITIONS, GET_TERM_CONDITIONS } from "../../services/apiRoutes"
import { genericPost } from '../../services/authServices';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CustomLoader from "../../components/common/CustomLoader";
import MessageBox from "../../components/common/CustomMessageBox";
import CustomDelete from '../common/CustomDeleteAlert';
import { AuthContext } from "../../context/AuthContext";
import { genericGet, } from "../../services/apiServices";
import { CircularProgress } from "@mui/material";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import {
    SaveRounded,
} from "@mui/icons-material";
import CustomButton from "../common/CustomButton";
import { AccessDenied, getVoucher, hasCreatePermission, hasDeletePermission, hasEditPermission, hasViewPermission } from "../../services/CommonServices";
import CustomAutocomplete from "../common/CustomAutoComplete";
import CustomMaster from "../common/CustomMaster";
import { Editor } from "react-draft-wysiwyg";
import { stateToHTML } from "draft-js-export-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useLocation } from "react-router-dom";
import draftToHtml from 'draftjs-to-html';
import { EditorState, convertFromHTML, ContentState, convertToRaw } from "draft-js";
import UpdateTermConditions from "./UpdateMaster/UpdateTermConditions";
import CustomModal from "../common/CustomModal";
import axios from "axios";
import { t } from "../../constants/translationHelper";

const title = "Terms and Conditions";

const ValidationSchema = Yup.object().shape({
    voucherName: Yup.string().required('Voucher Name is required'),
    // termConditions: Yup.string().required('Term Conditions is required'),
});

const TermConditions = () => {
    const { token } = useContext(AuthContext)
    const [modal, setModal] = useState(false);
    const [permission, setPermissions] = useState()
    const [data, setData] = useState([]);
    const [voucher, setVoucher] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const [updateModal, setUpdateModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')


    const ReadMore = ({ content, maxLength = 100 }) => {
        const [isReadMore, setIsReadMore] = useState(true);
        const toggleReadMore = () => {
            setIsReadMore(!isReadMore);
        };
        const contentStr = typeof content === "string" ? content : String(content || "");
        const shortContent = contentStr.slice(0, maxLength);
        return (
            <div>
                <div
                    dangerouslySetInnerHTML={{
                        __html: isReadMore ? shortContent : contentStr,
                    }}
                />
                {contentStr.length > maxLength && (
                    <span
                        onClick={toggleReadMore}
                        style={{ color: "#AEAEAE", cursor: "pointer" }}
                    >
                        {isReadMore ? "...read more" : " show less"}
                    </span>
                )}
            </div>
        );
    };




    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    })
    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const onEditorStateChange = (state) => {
        setEditorState(state);
    };

    const convertToHTMLContent = () => {
        const contentState = editorState.getCurrentContent();
        // const htmlContent = stateToHTML(contentState);
        const htmlContent = draftToHtml(convertToRaw(contentState));
        return htmlContent;
    };

    const location = useLocation();
    const currentPath = location.pathname;

    useEffect(() => {
        let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
        let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
        let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
        let createPermision = hasCreatePermission(currentPath, rolePermisionsData?.permissions)
        let viewPermision = hasViewPermission(currentPath, rolePermisionsData?.permissions)

        setPermissions({
            edit: editPermision,
            delete: deletePermission,
            create: createPermision,
            view: viewPermision,
        })
    }, [])
    const handleUpdateClick = (id) => {
        setSelectedId(id);
        setUpdateModal(true);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
    };


    const columns = useMemo(
        () => [
            { accessorKey: "index", header: "SN.", size: 50, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
            {
                accessorKey: "voucherName", header: "Voucher", tableHeader: {
                    justifyContent: 'flex-start',
                }, size: 50
            },
            {
                accessorKey: "termConditions",
                header: "Terms and Conditions",
                tableStyle: { textAlign: "left" },
                size: 200,
                Cell: ({ row }) => {
                    return <ReadMore content={row.original.termConditions || ''} maxLength={150} />;
                },
                enableSorting: false,
            },

            {
                accessorKey: "action",
                header: "Action",
                size: 10,
                Cell: ({ row }) => (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>

                            {permission?.edit &&
                                <IconButton onClick={() => handleUpdateClick(row.original.id)}>
                                    <ModeEditOutlineOutlinedIcon style={{ color: "#050C9C" }} />
                                </IconButton>
                            }
                            {permission?.delete &&
                                <IconButton
                                    onClick={() => handleOpenDeleteAlert(row.original.id)}
                                >
                                    <DeleteOutlineOutlinedIcon style={{ color: "#E4003A" }} />
                                </IconButton>
                            }
                        </div>
                    </>
                ),
            },
        ],
        [permission]
    );

    const fetchData = async () => {
        setLoading(true)
        try {
            const response = await genericGet({ url: GET_TERM_CONDITIONS });
            if (response.data) {
                const CustumData = response.data.termConditions.map((data, index) => ({
                    ...data,
                    index: (index + 1).toString().padStart(2, '0'),
                    id: data.id || '',
                    voucherName: data.voucher?.voucherName || '',
                    // termConditions: renderHtmlContent(data.termConditions || ''),
                    termConditions: data.termConditions || '',
                }));
                setData(CustumData);
                setLoading(false)

            } else {
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            console.error("Error fetching ", error);
        }
    };

    const getCommonData = async () => {
        const voucherData = await getVoucher();
        setVoucher(voucherData);

    }

    useEffect(() => {
        fetchData()
        getCommonData()
    }, [token])

    const handleOpen = () => {
        setModal(true);
    };

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const htmlContent = convertToHTMLContent();
            const termConditions = htmlContent;
            const payload = {
                voucherName: values.voucherName,
                termConditions: termConditions,
            };
            const response = await genericPost(CREATE_TERM_CONDITIONS, payload);
            if (response.status === 201) {
                setMessage({
                    open: true,
                    text: response?.data?.message || "added successfully",
                    type: "success",
                });
                setTimeout(() => {
                    fetchData();
                }, 1000);
                resetForm();
                setEditorState(EditorState.createEmpty());

            }
            else if (response.status === 409) {
                setMessage({
                    open: true,
                    text: response?.data?.message || 'Already Exists ',
                    type: 'error',
                });
            }
            else {
                alert('Something went wrong');
            }
        } catch (error) {
            alert('Something went wrong');
        } finally {
            setSubmitting(false);
        }
    };

    const handleDelete = async (id) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_TERM_CONDITIONS(id), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });
            if (response.status === 200) {
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
                setDeleteAlert(false);

            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related terms and condition exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };

    const [formData] = useState({
        voucherName: '',
        termConditions: '',

    });
    const defaultView = 'termConditions';
    const mainContent = (
        <>
            <Box sx={{ padding: "10px" }}>
                {permission?.create &&
                    <Formik
                        initialValues={formData}
                        validationSchema={ValidationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ isSubmitting, errors, touched, setFieldValue, values, handleChange }) => (
                            <Form>
                                <Grid container spacing={2} sx={{ px: "0%" }}>
                                    <Grid item xs={12} md={4}>
                                        <CustomAutocomplete
                                            options={voucher}
                                            fieldLabel="Voucher"
                                            required={true}
                                            getOptionLabel={(option) => option.title}
                                            value={voucher.find((option) => option.id === values.voucherName) || null}
                                            onChange={(e, newValue) =>
                                                setFieldValue('voucherName', newValue ? newValue.id : '')
                                            }
                                            placeholder="Select Voucher"
                                            error={touched.voucherName && !!errors.voucherName}
                                            helperText={touched.voucherName && errors.voucherName}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={10}>
                                        <FormLabel sx={{ paddingBottom: "10px" }} style={fieldLabelstyle}>{t("Terms and Conditions")}</FormLabel>
                                        <Editor
                                            editorState={editorState}
                                            onEditorStateChange={onEditorStateChange}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            wrapperStyle={{
                                                border: '1px solid #CED4DA', borderRadius: '4px',
                                            }}
                                            editorStyle={{ padding: "10px" }}
                                            toolbar={{
                                                options: [
                                                    'inline',
                                                    'blockType',
                                                    'fontSize',
                                                    'fontFamily',
                                                    'list',
                                                    'textAlign',
                                                    'colorPicker',
                                                    'link',
                                                    'emoji',
                                                    'remove',
                                                    'history'
                                                ],
                                                inline: {
                                                    inDropdown: false,
                                                    options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
                                                },
                                                blockType: {
                                                    inDropdown: true,
                                                    options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote', 'Code'],
                                                },
                                                fontSize: {
                                                    options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96],
                                                },
                                                list: {
                                                    inDropdown: false,
                                                    options: ['unordered', 'ordered', 'indent', 'outdent'],
                                                },
                                                textAlign: {
                                                    inDropdown: false,
                                                    options: ['left', 'center', 'right', 'justify'],
                                                },
                                                link: {
                                                    inDropdown: false,
                                                    options: ['link', 'unlink'],
                                                },
                                                history: {
                                                    inDropdown: false,
                                                    options: ['undo', 'redo'],
                                                },
                                            }}
                                        />

                                    </Grid>
                                    <Grid item xs={12} md={2}>
                                        <Box sx={{ pt: 18 }}>
                                            <CustomButton
                                                startIcon={<SaveRounded />}
                                                title={isSubmitting ? <CircularProgress size={20} color="inherit" /> : "Save"}
                                                size="small"
                                                variant="contained"
                                                type="submit"
                                                disabled={isSubmitting}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                }
                <CustomLoader open={loading} />
                <DataTable
                    title={title}
                    columns={columns}
                    data={data}
                    handleOpen={handleOpen}
                />
                <CustomModal
                    open={updateModal} handleClose={handleCloseUpdate}>
                    <UpdateTermConditions
                        handleClose={handleCloseUpdate}
                        id={selectedId}
                        fetchData={fetchData}
                        setMessage={setMessage}
                        voucher={voucher}

                    />
                </CustomModal>

                <MessageBox
                    open={message.open}
                    onClose={() => setMessage({ ...message, open: false })}
                    message={message.text}
                    handleClose={() => setMessage({ ...message, open: false })}
                    type={message.type}
                />
                <CustomDelete
                    handleDelete={handleDelete}
                    open={deleteAlert}
                    rowId={rowId}
                    handleClose={() => setDeleteAlert(false)}
                />
            </Box>
        </>
    );
    const getMainContent = (mainContent, permission) => {
        return permission?.view ? mainContent : null;
    };


    return (

        <>
            <CustomMaster
                defaultView={defaultView}
                mainContent={getMainContent(mainContent, permission)}
            />
            {!permission?.view && <AccessDenied />}
        </>
    );
};
export default TermConditions;

const fieldLabelstyle = {
    color: "#212529",
    fontWeight: "600",
    fontSize: "14px",
};